const productForm = document.querySelector('.product-form form');
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.bundle-option').forEach((option) => {
    option.addEventListener('click', (event) => {
      option.classList.toggle('selected');

      const idName = 'items[' + option.getAttribute('data-index') + '][id]';
      const quantityName = 'items[' + option.getAttribute('data-index') + '][quantity]';

      if (option.classList.contains('selected')) {
        let productInput = document.createElement("input");
        let productQuantityInput = document.createElement("input");

        productInput.setAttribute('type', 'hidden');
        productInput.setAttribute('name', idName);
        productInput.setAttribute('value', option.getAttribute('data-variant-id'));
        productQuantityInput.setAttribute('type', 'hidden');
        productQuantityInput.setAttribute('name', quantityName);
        productQuantityInput.setAttribute('value', '1');
        productForm.querySelector('button[name="add"] span').innerHTML = productForm.querySelector('button[name="add"]').dataset.atcMultiple;
        productForm.appendChild(productInput);
        productForm.appendChild(productQuantityInput);
      } else {
        document.querySelector('input[name="' + idName +'"]').remove();
        document.querySelector('input[name="' + quantityName +'"]').remove();
        if (!Array.from(document.querySelectorAll('.bundle-option')).some(option => option.classList.contains('selected'))) {
          productForm.querySelector('button[name="add"] span').innerHTML = productForm.querySelector('button[name="add"]').dataset.atc;
        }
      }
    });
  });
});
